export default "__VITE_PUBLIC_ASSET__ace3ab25__"